import { render } from "./faq.vue?vue&type=template&id=25d58e88&scoped=true"
import script from "./faq.vue?vue&type=script&lang=js"
export * from "./faq.vue?vue&type=script&lang=js"

import "./faq.vue?vue&type=style&index=0&id=25d58e88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25d58e88"]])

export default __exports__